'use client'

import 'antd/dist/antd.css'

import Image from 'next/image'
import Link from 'next/link'
import { ReactNode } from 'react'
import styled from 'styled-components'

import { spaces } from '@/config/global-parameters'
import GlobalStyle from '@/styles/GlobalStyles'

import BannerProvider from '../providers/BannerProvider'
import Footer from './consejo/components/Footer'
import Header from './consejo/components/Header'
import Menu from './consejo/components/Menu'
import reportAnalytics from './plebiscito/components/plebiscito/reportAnalytics'

interface ILayout {
  children: ReactNode
}

const Layout = ({ children }: ILayout) => {
  return (
    <>
      <BannerProvider>
        <GlobalStyle />
        <ServelMsg>
          Cálculos de resultados por Unholster a partir de cómputos parciales del Servel
        </ServelMsg>
        <Wrapper>
          <LinkMobile
            href="https://info.unholster.com/suscribirse-noticias"
            onClick={() => reportAnalytics('clicked_banner', "https://info.unholster.com/suscribirse-noticias")}
            passHref
            target="_blank"
          >
            <BannerMobile
              alt="banner-unholster-mobile"
              height={47}
              src="/banners/DC_Banner_Unholster.gif"
              width={565 / 47}
            />
          </LinkMobile>
          <Header />
          <Menu />
          <Content>{children}</Content>
          <Footer />
        </Wrapper>
      </BannerProvider>
    </>
  )
}

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: ${spaces.maxWidth};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
`

const LinkMobile = styled(Link)`
  @media (min-width: ${spaces.tabletBreakpoint}) {
    display: none;
    pointer-events: none;
  }
`
const BannerMobile = styled(Image)`
  width: 100%;
  height: min-content;
`

const Content = styled.div`
  padding: ${spaces.m};
  max-width: ${spaces.maxContent};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: auto;
  @media (max-width: ${spaces.tabletBreakpoint}) {
    padding: ${spaces.xs};
  }
`

const ServelMsg = styled.div`
  font-size: 10px;
  background-color: #4f4f4f;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  word-break: break-word;
  text-align: center;
  padding: 5px;
`

export default Layout
